import { styled } from "styled-components";

export const Container = styled.div``;

export const Row = styled.span``;
